import { dom } from "./dom";
dom.install(window);

export { dom };
